import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
var useModalStore = function () { return useContext(MobXProviderContext).modalStore; };
export default useModalStore;
//# sourceMappingURL=UseModalStore.js.map